import BaseMessage from './base-message';

/**
 *
 * @module HLSJSMediaEvent
 * @desc Message containing a type and event object
 * @class HLSJSMediaEvent
 *
 */
class HLSJSMediaEvent extends BaseMessage {

    /**
     *
     * @param {string} type
     * @param {Event} event s
     * @constructor
     *
     */
    constructor(type, mediaPlayer, data) {

        super(type, mediaPlayer, data);

    }

}

export default HLSJSMediaEvent;
